module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--s2-3055f66da0c53f2e0fb68196b648acca.svg";